module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAALdJREFUKFN9kskVwjAMBedXCTWwJ6EM9q0G6uBIU58nnm0MBHyLNCMpsmX7BlwlXfhzbHfAQLYbYA1MJZ37HNstsAImCqAKfEm2F8AmF3wKSYpEdJrlTrZnwLaOFSFJBQAit6/hYN6EJE0SGJ+lW56kTxgDhwTMJZ3qRXyOlOF57CKJjaRc4DWS7QwXoIp1knblH1LiCLQ5UW0vCkVuKWkTFzcCYs5n4MfFZakL4Z6eRi9cdYrCwwfLvGNo4DwBVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/home/close.png
// module id = trbj
// module chunks = 1